<template>
  <div class="main">
    <div class="banner">
      <h1 class="banner-title">
        打造专业信息化管理系统
        <br />让门店管理更智慧
      </h1>
      <div class="banner-desc">更智慧，更高效，更放心</div>
      <router-link class="apply-link" to="/try">申请试用</router-link>
    </div>
    <div class="solve">
      <div class="solve-row" v-for="item in solveList" :key="item.id">
        <div class="solve-container w">
          <div class="solve-info">
            <h3 class="solve-h3">{{item.name}}</h3>
            <div class="solve-desc">{{item.desc}}</div>
            <ul class="solve-list">
              <li v-for="items in item.list" :key="items">{{items}}</li>
            </ul>
            <to-try class-name="c-link" type="1"></to-try>
          </div>
          <svg-icon :icon-class="item.path" class-name="solve_svg"></svg-icon>
        </div>
      </div>
    </div>

    <m-to-try class-name="c-apply" type="2"></m-to-try>
  </div>
</template>
<script>
export default {
  data() {
    return {
      solveList: [
        {
          path: "solve_svg1",
          name: "对于管理者",
          desc: "成功管理者的经营法宝",
          list: [
            "管理：门店高效管理，产品结构合理，库存达最优状态",
            "决策：掌控经营数据，挖掘价值数据，轻松诊断经营状态",
            "资源：获取行业最新动向，接线行业智囊大咖"
          ]
        },
        {
          path: "solve_svg2",
          name: "对于店员",
          desc: "塑造药房专业服务人才，助力业绩增长",
          list: [
            "专业服务：提供学习工具，提升专业度，树立优质服务形象",
            "高效工作：收银便捷，补货高效，库存合理，盘点轻松高效",
            "精准营销：精细化管理会员，捕获消费心理，实现精准营销"
          ]
        },
        {
          path: "solve_svg3",
          name: "对于消费者",
          desc: "稳抓消费心理，增加会员黏性",
          list: [
            "优质服务：药师咨询，慢病建档，健康资讯，电话回访",
            "触达需求：会员营销，专业服务",
            "慢病管理，用药提醒，健康检测"
          ]
        }
      ]
    };
  }
};
</script>
<style lang='scss' scoped>
$color: #213d81;
/deep/ .c-link {
  background: $color;
}

/deep/ .c-apply {
  color: $color;
  background: url("../../assets/imgs/apply_bg.png") no-repeat top center / 100%
    100%;
}
.banner {
  width: 100%;
  height: 1144px;
  background: url("../../assets/imgs/m_solve_bg.png") no-repeat top center /
    100%;
  overflow: hidden;
  .banner-title {
    color: #fff;
    margin: 355px auto 0;
    text-align: center;
    font-size: 56px;
    font-weight: 300;
    line-height: 88px;
  }
  .banner-desc {
    color: #fff;
    margin-top: 28px;
    text-align: center;
    font-size: 34px;
    font-weight: 400;
    line-height: 48px;
  }
  .apply-link {
    display: block;
    width: 240px;
    height: 72px;
    border-radius: 4px;
    border: 2px solid #fff;
    font-size: 32px;
    font-weight: 400;
    color: #fff;
    line-height: 68px;
    margin: 28px auto 0;
    text-align: center;
  }
}
.solve {
  .solve-row {
    padding: 82px 32px;
    &:nth-child(2n) {
      background: #f1f2f5;
    }

    .solve-info {
      .solve-h3 {
        color: #2f393f;
        font-size: 44px;
        font-weight: 300;
        line-height: 60px;
      }
      .solve-desc {
        color: #2f393f;
        margin-top: 32px;
        font-size: 36px;
        font-weight: 300;
        line-height: 50px;
      }
      .solve-list {
        margin-top: 64px;
        li {
          font-weight: 400;
          color: #6c737d;
          margin-bottom: 24px;
          font-size: 28px;
          line-height: 40px;
        }
      }
    }
    .solve_svg {
      width: 100%;
      height: 625px;
      margin-top: 88px;
    }
  }
}
</style>
